import { IconButton } from '@/shared/ui/icon-button'
import { useThemeStore } from '../model/store'

export function ThemeSwitcher() {
  const scheme = useThemeStore((s) => s.scheme)
  const setScheme = useThemeStore((s) => s.setScheme)

  return (
    <IconButton
      icon={scheme === 'dark' ? 'sun' : 'moon'}
      aria-label="Переключить тему"
      variant="raise"
      size="sm"
      onClick={() => setScheme(scheme === 'dark' ? 'light' : 'dark')}
    />
  )
}
